import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
    locales: ['en', 'fr', 'es'],
    defaultLocale: 'en',
    // No locale prefix in URL - locale is determined by cookie
    localePrefix: 'never'
});
